<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height">
    <v-row no-gutters fill-height>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle" >
          <template v-slot:body>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <i-card-top
                    class="d-md-flex"
                    outlined
                    :useBtnList="useBtnList"
                    @btnRetrieve="btnRetrieve()" @btnPrint="btnPrint()" @btnSaveExcel="btnSaveExcel()"
                  >
                    <template v-slot:body>
                      <v-row no-gutters class="center pa-2 pb-0">
                        <i-label :label="'Ship No : '"/>
                        <v-col cols="1">
                          <v-select
                            v-model="shipNo"
                            :items="shipNoList"
                            item-value="shipNo"
                            return-object
                            single-line
                            outlined
                            dense
                            @change="changeShipNo"
                          ></v-select>
                        </v-col>
                        <i-label :label="'Rev.No : '" class="pl-2"/>
                        <v-col cols="1" >
                          <v-text-field 
                            v-model="revNo" 
                            dense 
                            outlined 
                            hide-details="auto"
                          />
                        </v-col>
                        <i-label :label="'Area : '" class="pl-2"/>
                        <v-col cols="1">
                          <v-select
                            v-model="areaCd"
                            :items="areaList"
                            item-value="block"
                            return-object
                            single-line
                            outlined
                            dense
                            :label="'All'"
                            @change="btnRetrieve()"
                          ></v-select>
                        </v-col>
                        <i-label :label="'Feed No : '" class="pl-2"/>
                        <v-col cols="1">
                          <v-select
                            v-model="feedNo"
                            :items="feedNoList"
                            item-value="setPoint"
                            return-object
                            single-line
                            outlined
                            dense
                            :label="'All'"
                            @change="btnRetrieve()"
                          ></v-select>
                        </v-col>
                        <i-label :label="'Cable Type : '" class="pl-2"/>
                        <v-col cols="1">
                          <v-select
                            v-model="cableType"
                            :items="cableTypeList"
                            item-value="cableType"
                            return-object
                            single-line
                            outlined
                            dense
                            :label="'All'"
                            @change="btnRetrieve()"
                          ></v-select>
                        </v-col>
                      </v-row>
                    </template>
                  </i-card-top>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" class="pt-1">
                  <DxDataGrid id="epms6300" 
                    :ref="epms6300Ref"
                    class="hipGridHeight1_1"
                    :data-source="gridMainList" 
                    :remote-operations="false" 
                    :hover-state-enabled="true"
                    :allow-column-resizing="true" 
                    :allow-column-reordering="true"
                    :row-alternation-enabled="true" 
                    :show-borders="true" 
                    :width="grid.width"
                    :show-row-lines="true" 
                    key-expr="id" 
                    :focused-row-enabled="true"
                    :column-hiding-enabled="false" 
                    :selection="{ mode: 'none' }"
                    :sorting="{ mode: 'none' }"
                    :word-wrap-enabled="true"
                  >
                    <DxPaging :enabled="true" :page-size="10" />
                    <DxColumn data-field="system" caption="Sys." width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="supArea" caption="Area" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="revision" width="3%" data-type="string" alignment="center" header-cell-template="revNo" :allow-editing="false" />
                    <template #revNo>
                      <div>Rev.<br>No</div>
                    </template>
                    <DxColumn data-field="cutting" width="3%" data-type="string" alignment="center" header-cell-template="cutYn" :allow-editing="false" />
                    <template #cutYn>
                      <div>Cut<br>Y/N</div>
                    </template>
                    <DxColumn data-field="feedNo" width="5%" data-type="string" alignment="center" header-cell-template="feedNo" :allow-editing="false" />
                    <template #feedNo>
                      <div>Feed<br>No.</div>
                    </template>
                    <DxColumn data-field="cableAbbr" width="5%" data-type="string" alignment="center" header-cell-template="cableType" :allow-editing="false" />
                    <template #cableType>
                      <div>Cable<br>Type</div>
                    </template>
                    <DxColumn data-field="qty" caption="Qty" width="3%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn caption="From" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="fdeck" caption="Deck" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="fequip" caption="Equipment" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn caption="To" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="tdeck" caption="Deck" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="tequip" caption="Equipment" width="10%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn data-field="routepath" caption="Cable Route" width="18%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="totalLength" width="3%" data-type="string" alignment="center" header-cell-template="len" :allow-editing="false" />
                    <template #len>
                      <div>LEN<br>(MR)</div>
                    </template>
                    <DxColumn data-field="areaLength" width="5%" data-type="string" alignment="center" header-cell-template="areaCable" :allow-editing="false" />
                    <template #areaCable>
                      <div>Area<br>Cable<br>Length</div>
                    </template>
                    <DxColumn caption="Set Len" alignment="center" :allow-editing="false" >
                      <DxColumn data-field="flength" caption="From" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="tlength" caption="To" width="3%" data-type="string" alignment="center" :allow-editing="false" />
                    </DxColumn>
                    <DxColumn data-field="setPoint" width="5%" data-type="string" alignment="center" header-cell-template="setPoint" :allow-editing="false" />
                    <template #setPoint>
                      <div>Set<br>Point</div>
                    </template>
                    <DxColumn data-field="blockNo" caption="Block" width="5%" data-type="string" alignment="center" :allow-editing="false"/>
                    <DxColumn data-field="rmk" caption="Remark" width="7%" data-type="string" alignment="center" :allow-editing="false" />
                  </DxDataGrid>
                </v-col>
              </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { DxDataGrid, DxEditing, DxColumn  } from 'devextreme-vue/data-grid'
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // base page 추가
import BaseDataGrid from '@/components/base/BaseDataGrid.vue' // 데이타 그리드 사용시 베이스 추가
import { getShipList , getRevNo } from '@/api/view/hip/6/epms6400.js'
import { getAreaList , getFeedNoList , getCableTypeList , getEpms6300List , epms6300Xls } from '@/api/view/hip/6/epms6300.js'
import { reportView} from '@/api/view/hip/common/common.js'

export default {
  name: 'epms6300',
  mixins: [baseview, BaseDataGrid],
  components: {
    ICardVertical,
    'i-card-top': iCardTop,
    DxDataGrid,
    DxColumn,
    DxEditing
    
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      useBtnList: ['btnRetrieve' , 'btnPrint' , 'btnSaveExcel'],
      epms6300Ref: 'epms6300Ref',
      gridMainList: [],

      shipNo: '',
      shipNoList: [],
      revNo: '',
      areaCd: 'All',
      areaList: [],
      feedNo: 'All',
      feedNoList: [],
      cableType: 'All',
      cableTypeList: []
      
    }
  },
  computed: {
    gridMainInstance() {
      return this.GetDataGrid(this.epms6300Ref)
    },
  },
  mounted() {
    this.shipList()
    this.gridMainInstance.option('defaultPaging', false)
  },
  methods: {
    async shipList(){
      try {
        this.openLoading('searching')
        let params = {
          makerCd: this.$store.state.user.makerCd,
        }
        await getShipList(params).then(res => {
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
        })
      } finally {
        this.endLoading()
      }
    },
    async getList(){
      try {
        this.openLoading('searching')
        let params = {
          shipNo: this.shipNo,
        }
        await getAreaList(params).then(res => {
          this.areaList.push('All')
          res.list.forEach(e => {
            this.areaList.push(e.areaCd)
          });
        })
        await getRevNo(params).then(res => {
          this.revNo = res.list[0].revNo
        })
        await getCableTypeList(params).then(res => {
          this.cableTypeList.push('All')
          res.list.forEach(e => {
            this.cableTypeList.push(e.cableType)
          });
        })
      } finally {
        let params = {
          shipNo: this.shipNo,
          revNo: this.revNo,
        }
        await getFeedNoList(params).then(res => {
          this.feedNoList.push('All')
          res.list.forEach(e => {
            this.feedNoList.push(e.feedNo)
          })
        })
        this.endLoading()
      }
    },
    async epms6300List(){
      try {
        this.openLoading('searching')
        let params = {
          shipNo: this.shipNo,
          revNo: this.revNo,
          areaCd: this.areaCd === 'All' ? '' : this.areaCd,
          feedNo: this.feedNo === 'All' ? '' : this.feedNo,
          cableType: this.cableType === 'All' ? '' : this.cableType ,
        }
        await getEpms6300List(params).then(res => {
          res.list.forEach(e => {
            e.id = e.rnum
          });
          this.gridMainList = res.list
        })

      } finally {
      this.endLoading()
      }
    },
    changeShipNo(e){
      this.getList()
    },
    btnRetrieve(){
      if(!this.areaCd || this.areaCd === '' || !this.feedNo || this.feedNo === '' || !this.cableType || this.cableType === ''){
        this.vToastify(this.$t('Please select Area/Feed No./Cable Type!'), 'warn')
        return
      }
      this.gridMainList = []
      this.epms6300List()
    },
    btnPrint(){
      const param = {
        fileName: 'epms6300prt.jrxml',
        as_ship_no: this.shipNo,
        as_area: this.areaCd === 'All' ? '' : this.areaCd,
        as_feed_no: this.feedNo === 'All' ? '' : this.feedNo,
        as_cbl_type: this.cableType === 'All' ? '' : this.cableType,
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    btnSaveExcel(){
      const param = {
        shipNo: this.shipNo,
        revNo: this.revNo,
        areaCd: this.areaCd === 'All' ? '' : this.areaCd,
        feedNo: this.feedNo === 'All' ? '' : this.feedNo,
        cableType: this.cableType === 'All' ? '' : this.cableType
      }
      epms6300Xls(param)
    },
  }
}
</script>
<style lang="scss" scoped>
</style>